import React,{useEffect} from 'react';
import './Homepage.css';
import AOS from 'aos';



const HomepageSecondSection = () => {
  useEffect(() => {
    AOS.init();
        window.scrollTo(0, 0)
  }, [])
  return (
    <div className='container-fluid' id='homepage-second-section'>
     <div className="row">
        <div className="col left-col"  data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
            <h3>About Our Company</h3>
            <h1>Unique Technologies</h1>
            <p>Unique Technologies is a leading automation solution providing company based at Noida, GautamBuddha Nagar. We are engaged in automation solutions and products which are well suited to plant's technical needs and commercial viability. Unique Technologies founded in 2012. An ISO 14001: 2015 and ISO 9001 : 2015 certified company .We offer better services of Water Treatment Plant, Waste Water Treatment Plant / STP , Tubewell Automation system, Solar Water Pumping System and Street Light Automation System. Unique Technologies is well known as a reliable manufacturer of PLC/SCADA Automation panel, VFD Panel.</p>
            <div className="know-more-btn">
                know more
            </div>
        </div>
        <div className="col right-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
            <img src="img-data/apple-touch-icon.png" 
            alt="" />
            <h1 style={{color:"white"}}>Unique Technologies</h1>
        </div>
     </div>
    </div>
  )
}

export default HomepageSecondSection
